import create from 'zustand';

const useShipmentQueryStore = create<ShipmentQueryStoreState>((set, get) => ({
  shipmentQuery: null,

  setShipmentQuery: async (shipmentQuery: any) => {
    set({ shipmentQuery: shipmentQuery })
  }
}))

interface ShipmentQueryStoreState {
  shipmentQuery: any,
  setShipmentQuery: (shipmentQuery: any) => void,
}

export default useShipmentQueryStore;